import { useState } from 'react';
import { useDispatch } from 'react-redux';
import fm from 'format-message';
import PropTypes from 'prop-types';
import textStyles from 'config/branding/textStyles';
import { useStyletron } from '@activebrands/core-web/libs/styletron';
import { removeVoucher } from '@activebrands/core-web/state/basket/actions';
import StateIcon from 'components/icons/StateIcon';

const Discount = ({ $style = {}, discount = {} }) => {
    const [css] = useStyletron();
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const isVoucher = discount.discountType === 'voucher';

    const removeDiscount = () => {
        setLoading(true);

        dispatch(removeVoucher(discount.id)).then(() => {
            setLoading(false);
        });
    };

    return (
        <div
            className={css({
                display: 'flex',
                alignContent: 'center',
                justifyContent: 'space-between',
                padding: ['0 12px 8px', null, null, null, null, '0 24px 12px'],
                ...textStyles['Regular-14/100'],
                ...$style,
            })}
        >
            <div>
                {isVoucher
                    ? discount.externalId
                        ? fm(`Discount code: {discount}`, discount)
                        : `"${discount.name}"`
                    : discount.name}

                {isVoucher && (
                    <button className={css({ marginLeft: '8px' })} type="button" onClick={removeDiscount}>
                        {fm('Remove')}
                        <StateIcon $style={{ marginLeft: '8px' }} state={loading ? 'loading' : 'reset'} />
                    </button>
                )}
            </div>
            <div className={css({ color: 'var(--color-text-error)' })}>{discount.discount}</div>
        </div>
    );
};

Discount.propTypes = {
    $style: PropTypes.object,
    discount: PropTypes.object.isRequired,
};

export default Discount;
